import { UserResponse } from './../../shared/dtos/userResponse';
import { DroitService } from './../../shared/services/simple/droit.service';
import { GlobalSettingsService } from './../../core/gobal-settings.service';
import { APICONSTANTS } from 'src/app/shared/constants/api-constants';
import { environment } from 'src/environments/environment';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/shared/services/session.service';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { MatSidenav } from '@angular/material/sidenav';
import { HostnameService } from 'src/app/shared/services/basic/hostname.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public envName = environment.envName;
  canUseMock = false;
  mockEnabled = false;
  user: UtilisateurModel;
  @Input() snav: MatSidenav;
  bpDisplayState = false; // true activé - les fonctions bp sont masquées / false désactivé - les fonctions bp sont affichées
  bpEnvState = false;
  isDeleg: any; // true activé - les fonctions bp sont masquées / false désactivé - les fonctions bp sont affichées
  droitAdminUser  = false;  // pour savoir si on a les doits admin user
  droitAdminRef  = false;  // pour savoir si on a les doits admin referentiel
  droitsInterface = false; // pour savoir si on a les doits interface
  constructor(
    public router: Router,
    private sessionService: SessionService,
    private globalSettingsService: GlobalSettingsService,
    private hostnameService: HostnameService,
    private droitService: DroitService
  ) {
    this.getDisplayBpFeatures();
  }

  ngOnInit(): void {
    this.bpEnvState = environment.BP_ACTIF;
    this.isDeleg = localStorage.getItem('isDeleg') === "activé" ? true : false;
    this.sessionService.currentUser.subscribe(user => {
      this.user = user;
      if (user) {
        const droitsAdmin = user.droits.filter(droit =>
          (droit.niveau === 1 && droit.bDeleg == this.isDeleg) &&
          (droit.type.toUpperCase() === 'ADMIN')
        );
        if (droitsAdmin && droitsAdmin.length > 0){
          this.droitAdminUser = true;
        }
        const droitsAdminRef = user.droits.filter(droit => ((droit.niveau === 2) && (droit.type.toUpperCase() === 'ADMIN')));
        if (droitsAdminRef && droitsAdminRef.length > 0){
          this.droitAdminRef = true;
        }
        const droitsInterface = user.droits.filter(droit => (droit.type.toUpperCase() === 'INTERFACE'));
        if (droitsInterface && droitsInterface.length > 0){
          this.droitsInterface = true;
        }
      }
    });
  }


  switchToMock(): void {
    this.mockEnabled = true;
    APICONSTANTS.URLAPI.next(this.hostnameService.getUrl() + 'mock/');
    localStorage.setItem('MOCK', JSON.stringify(true));
    location.reload();
  }

  switchToApi(): void {
    this.mockEnabled = false;
    APICONSTANTS.URLAPI.next(this.hostnameService.getUrl());
    localStorage.removeItem('MOCK');
    location.reload();
  }

  logout(): void {
    this.sessionService.logout().subscribe();
    this.user = undefined;
  }

  hideUnmaskBP(): void {
    this.globalSettingsService.hideUnmaskBp();
    this.getDisplayBpFeatures();
  }

  delegation(): void {
    this.globalSettingsService.delegation();
    this.isDeleg = this.globalSettingsService.isDeleg === "activé" ? true : false;
    this.sessionService.userResponseSubject.subscribe((userR: UserResponse) => {
      window.location.reload();
    },
    (error) => {
    });
  }

  getDisplayBpFeatures(): void {
    this.bpDisplayState = this.globalSettingsService.bpDisplayState;
  }

  manager_user(): void {
    this.router.navigate(['list-user']);
  }

  manager_referentiel(): void {
    this.router.navigate(['gestion-referentiel']);
  }
}
